import { render, staticRenderFns } from "./SurveillanceReport.vue?vue&type=template&id=e30764d2&scoped=true&"
import script from "./SurveillanceReport.vue?vue&type=script&lang=js&"
export * from "./SurveillanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30764d2",
  null
  
)

export default component.exports